import { PricingSheet } from "../types";

/**
 * User is the responsible person of the pricing sheet
 * @param pricingSheet
 * @param userEmail
 * @returns
 */
export const isResponsiblePerson = (
  pricingSheet: Pick<PricingSheet, "responsiblePerson">,
  userEmail?: string | null,
): boolean => {
  if (!userEmail) {
    return false;
  }
  return userEmail === pricingSheet.responsiblePerson;
};
